<template>
  <div class="student-infos-nav">
    <div class="suspend-nav" v-if="studentInfos.status !== 7 && studentSuspendDetail.suspendCourseDate">
      {{studentSuspendDetail.suspendCourseDate | formatDatetime("yyyy-MM-dd")}}学员将自动停课。如需调整停课日期，请撤销后再停课。<span class="cancel" @click="cancelSuspendCourse">撤销停课</span>
    </div>
    <div class="suspend-nav recovery" v-if="studentInfos.status == 7 && studentSuspendDetail.recoveryCourseDate" @click="suspendCourse">
      {{studentSuspendDetail.recoveryCourseDate | formatDatetime("yyyy-MM-dd")}}学员将自动复课。如需调整日期，去操作复课<van-icon name="arrow" style="color: #ED6A0C;"></van-icon>
    </div>
    <div class="top-nav" @click="$router.push('/baseStudentInfos?id='+stuId)">
      <div
        class="photo-nav"
        :style="getPhotoStyle">
        <span v-if="!studentInfos.photo">
          {{studentInfos.name && studentInfos.name.substr(-2)}}
        </span>
      </div>
      <div class="right-nav">          
        <div class="name">{{ studentInfos.name }} <van-icon name="arrow" /></div>
        <div class="flags-line">
          <span 
          :class="{
            'is-history': studentInfos.status == 6 || studentInfos.status == 99,
            'is-stop': studentInfos.status == 7,
            'is-unpaid': studentInfos.status == 0 }">
            {{ studentsStatusDict[studentInfos.status] }}
          </span>
          <span v-if="!hasFace">
            <van-icon 
              class-prefix="vxs-icon" 
              name="renlian" 
              size="10"
              :color=" hasFace ? 'var(--c2)' : 'var(--g6)'"
                />
            <span>未采集</span>
          </span>
          <span v-if="!getStudentBindStatus(studentInfos)">
            未绑定
          </span>
          <span>
            <van-icon 
              class-prefix="vxs-icon" 
              :name="studentInfos.sex === 1 ? 'nan' : 'nv'" 
              size="10"
              :color=" studentInfos.sex === 1 ? 'var(--c1)' : 'var(--c3)'"
              v-if="studentInfos.sex == 0 || studentInfos.sex == 1"
            />
            {{['女','男', '未知'][studentInfos.sex]}}
          </span>
          <span v-if="studentInfos.ageDesc || studentInfos.ageDesc === 0">
            {{studentInfos.ageDesc}}
          </span>
        </div>
        <div class="tags-nav">
          <span v-if="studentInfos.sellFollowTeacherList && studentInfos.sellFollowTeacherList.length>0">
            <span style="color:var(--g8);">跟进老师：</span>{{ studentInfos.sellFollowTeacherList.map(i=>i.followTeacherName).join('、') }}
          </span>
        </div>
        <div class="tags-nav">
          <span v-if="studentInfos.teachFollowTeacherList && studentInfos.teachFollowTeacherList.length>0">
            <span style="color:var(--g8);">教务老师：</span>{{ studentInfos.teachFollowTeacherList.map(i=>i.followTeacherName).join('、') }}
          </span>
        </div>
        <div class="tags-nav">
          <span v-if="studentInfos.studentCampusList && studentInfos.studentCampusList.length>0 && studentInfos.studentCampusList.filter(v=>v.name).length">
            <span style="color:var(--g8);">所属校区</span>：{{ studentInfos.studentCampusList.filter(v=>v.name).map(i=>i.name).join('、') }}
          </span>
        </div>
      </div>
      
    </div>
    <div 
      v-if="openWalleted" 
      class="wallet-nav" 
      @click="toEWallet(stuId)" 
      data-test="base-student-details-btn-eWallet">
      <div class="left" style="color:#A86D27;">
        <svg
          class="vxm-icon"
          font-size="16"
          aria-hidden="true"
        >
          <use xlink:href="#vxm-icon-a-bianzu7"></use>
        </svg>
          电子钱包：
         <span style="font-weight: var(--bold);" ><span>￥</span>{{studentInfos.walletTotalMoney | formatNumber}}</span>
      </div>
      <van-icon name="arrow" style="color: var(-g5);"></van-icon>
    </div>
    <div v-else class="no-wallet-line"></div>
    <div class="operation-nav">
      <div 
        :class="{disabled: hasTels}" 
        v-if="app.permission.op('add_audition')"
        @click="$router.push(`/auditionAdd?name=${studentInfos.name}&id=${studentInfos.id}`)"
        >
        <svg
          class="vxm-icon"
          font-size="28"
          aria-hidden="true"
        >
          <use xlink:href="#vxm-icon-shitingbeifen"></use>
        </svg>
        安排试听
      </div>
      <div 
        :class="{disabled: hasTels}" @click="toCall" 
        v-if="!app.teacher.user.disableDialNumber"
        data-test="base-student-details-btn-call">
        <svg
          class="vxm-icon"
          font-size="28"
          aria-hidden="true"
        >
          <use xlink:href="#vxm-icon-youxiaobeifen"></use>
        </svg>
        拨打电话
      </div>
      <div 
        :class="{disabled: hasTels}" 
        v-if="app.permission.op('charge')"
        @click="$router.push(`/sf1?studentId=${studentInfos.id}`)"
        >
        <svg
          class="vxm-icon"
          font-size="28"
          aria-hidden="true"
        >
          <use xlink:href="#vxm-icon-shoufeibeifen"></use>
        </svg>
        报名收费
      </div>
      <div @click="showMoreOperation = true" v-if="moreOperationCctions.length" data-test="base-student-details-btn-more">
        <svg
          class="vxm-icon"
          font-size="28"
          aria-hidden="true"
        >
          <use xlink:href="#vxm-icon-gengduobeifen"></use>
        </svg>
        更多
      </div>
    </div>
    <!-- 拨打电话列表 -->
    <van-action-sheet
      v-model="showTelsSheet"
      cancel-text="取消"
      close-on-click-action
      @cancel="showTelsSheet = false"
    >
      <div class="tels-sheet-content">
        <a
          class="van-action-sheet__item"
          v-for="relatio of studentInfos.studentParentRelation || []"
          :href="'tel:' + relatio.parentPhone"
          :key="relatio.parentPhone"
        >
          {{ relatio.parentPhone }}
          <span>{{ relatio.relation }}</span>
        </a>
      </div>
    </van-action-sheet>
    <!-- 更多操作列表 -->
    <van-action-sheet
      v-model="showMoreOperation"
      :actions="moreOperationCctions"
      cancel-text="取消"
      close-on-click-action
      @cancel="showMoreOperation = false"
      @select="onSelectOperation"
    />
    <van-dialog 
      getContainer="body"
      v-model="showToOldConfirm" 
      title="转为曾就读学员提醒" 
      class="student-to-old-dialog"
      @confirm="transferStudentToOld"
      confirm-button-text="确定"
      show-cancel-button>
      <div class="student-to-old-dialog-contain">
        <div style="text-align: center;">确认是否将“{{studentInfos.name}}”转为曾就读学员？</div>
        <div class="tips-contain">
          <!-- <p class="desc">{{transferCourseStrs}}</p> -->
          <p>转为曾就读学员后：</p>
          <ol>
            <!-- <li>启用的上课卡将自动停用；</li> -->
            <li>学员会自动移出所在班级，并移出“上课时间”为今天及之后的未点名排课</li>
            <li>重新购买后将自动恢复为在读学员</li>
          </ol>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    studentInfos: {
      type: Object,
      default: ()=>({})
    },
    studentSuspendDetail: {
      type: Object,
      default: ()=>({})
    }
  },
  inject: ['studentsStatusDict'],
  data () {
    return {
      stuId: this.$route.query.id,  
      showTelsSheet: false,
      showMoreOperation: false,
      showToOldConfirm: false,
      // transferCourseStrs: '',
    }
  },
  computed: {
    ...Vuex.mapState(["userInfo"]),
    moreOperationCctions () {
      let actions = [];
      let { status } = this.studentInfos; // （0仅登记，1在读，6历史学员，10休学，100退学）
      let historyOperation = [];

      // if(app.permission.op('charge')) {
      //   actions.push({ name: "收费", id: 1 });
      // }
      if (app.permission.op('edit_student')) {
        actions.push({ name: "编辑学员", id: 2 });  
      }
      if (status === 0) {
        historyOperation =  [{ name: "转为无效学员", id: 6 }];
      }
      if ((status === 7 || (status==1 && this.studentSuspendDetail.suspendCourseDate)) && app.permission.op('suspend_course')) { //1、停课”的学员2、“在读”但已提前设置了停课日期的学员
        historyOperation =  [{ 
          name: "复课", id: 9 
        }];
      }
      if (status === 1) {
        if (!this.studentSuspendDetail.suspendCourseDate && app.permission.op('suspend_course')) {
          historyOperation = [{
            name: "停课", id: 8 
          }];
        }
        if (app.permission.op('become_history')) {
          historyOperation =  historyOperation.concat([{ 
            name: "转为曾就读学员", id: 4 
          }]);
        }
      }
      if (status === 6 && app.permission.op('become_history')) {
        historyOperation = [{ name: "恢复为在读学员", id: 5 }]
      }
      if (status === 99) {
        historyOperation = [{ name: "恢复为未收费", id: 7 }];
      }
      if (historyOperation && historyOperation.length>0) {
        actions = actions.concat(historyOperation);
      }
      if (app.permission.op('delete_student')) {
        actions.push({ name: "删除", id: 3, color: "var(--c3)" });
      }
      return actions;
    },
    hasFace () {
      return app.tool.safeReadObjProp(this.studentInfos, 'studentFaceList.length');
    },
    hasTels () {
      return app.tool.safeReadObjProp(this.studentInfos, '.studentParentRelation.length');
    },
    openWalleted () {
      return app.tool.safeReadObjProp(this.userInfo, 'companyInfoVo.companyAppOpenList').indexOf("WALLET") > -1;
    }
  },
  methods:{
        // 拨打电话
    toCall() {
      let { studentParentRelation } = this.studentInfos;
      if (studentParentRelation && studentParentRelation.length) {
        this.showTelsSheet = true;
      } else {
        this.$toast("该学员暂无联系人，可点击“更多-编辑”进行添加");
      }
    },
    // 执行操作
    onSelectOperation(val) {
      switch (val.id) {
        case 1:
          this.gotoSf();
          break;
        case 2:
          this.toEditStudent();
          break;
        case 3:
          this.deleteSudent();
          break;
        case 4:
          this.showToOldConfirm = true;
          break;
        case 5:
          this.transferStudentToReading();
          break;
        case 6:
          this.toInValidStudent();
          break;
        case 7:
          this.toValidStudent();
          break;
        case 8: // 取消停课
          this.suspendCourse();
          break;
        case 9: // 复课
          this.suspendCourse();
          break;
        default:
          break;
      }
    },
    // 去收费
    gotoSf() {
      this.$router.push(`/sf1?studentId=${this.stuId}`);
    },
    toEditStudent () {
      if (this.studentInfos.id && app.permission.op('edit_student')) {
        this.$router.push("/baseStudentInput?id=" + this.studentInfos.id);
      }
    },
    // 标记为无效学员
    toInValidStudent() {
      // studentBecomeNonCharge
      this.$dialog
        .confirm({
          className: 'student-delete-dialog',
          title: "提示",
          messageAlign: 'left',
          message: `转为无效学员后，跟进中的意向将标记为转化失败，列表将默认隐藏这类学员，如需查看可通过筛选功能，选择无效学员`,
          confirmButtonText: "继续转无效",
          cancelButtonText: "取消", 
          confirmButtonColor: "var(--c3)" 
        })
        .then(() => {
          this.showLoading();
          this.$api
            .studentBecomeInvalid({
              studentIds: [this.stuId],
            })
            .then((res) => {
              if (res.code === 200) {                
                app.vue.$emit("studentInputSuccess");
                this.$toast.success('操作成功');
                return false;
              }
              if (res.code > 60000) {                
                this.$toast.fail(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    toValidStudent () {
      this.showLoading();
      this.$api
        .studentBecomeNonCharge({
          studentIds: [this.stuId],
        })
        .then((res) => {
          if (res.code === 200) {                
            app.vue.$emit("studentInputSuccess");
            this.$toast.success('操作成功');
            return false;
          }
          if (res.code > 60000) {                
            this.$toast.fail(res.msg);
          }
        });
    },
    // 删除学员
    deleteSudent() {
      this.$dialog
        .confirm({
          className: 'student-delete-dialog',
          title: "提示",
          messageAlign: 'left',
          message: `删除后，此学员及其关联的意向信息，将统一删除，不可恢复，是否确定删除学员？`,
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          confirmButtonColor: "var(--c3)",
        })
        .then(() => {
          this.$api
            .studentDelete({
              studentId: this.stuId,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$toast.success("删除成功");
                app.vue.$emit("refresh-student-list");
                this.$router.back();
              }
            });
        })
        .catch(() => {});
    },
    // 转为曾就读学员
    transferStudentToOld () {
      this.showLoading();
      this.$api
        .becomeHistory({
          studentIds: [this.stuId],
        })
        .then(async (res) => {
          if (res.code === 200) {                
            app.vue.$emit("studentInputSuccess");
            app.vue.$emit("refresh-student-school-card-list");
            this.$toast.success('操作成功');
            return false;
          }
          if (res.code > 60000) {                
            this.$toast.fail(res.msg);
          }
        });
    },
    // 转为就读学员
    transferStudentToReading () {
      this.showLoading();
      this.$api
        .becomeStudy({
          studentIds: [this.stuId],
        })
        .then(async (res) => {
          if (res.code === 200) {
            app.vue.$emit("studentInputSuccess");
            app.vue.$emit("refresh-student-school-card-list");
            // try {
            //   await this.getStudent();
            // } catch (err) {
            //   console.log('转就读后更新学员信息出错', err)
            // }
            this.$toast.success('操作成功');
            
            return false;
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg);
          }
        });
    },
    cancelSuspendCourse() { // 取消停课
      if (!app.permission.op('suspend_course')) {
        vant.Dialog.alert({
          title: "提示",
          message: "你没有学员停/复课的权限，请联系管理员",
          confirmButtonText: "我知道了",
        });
        return;
      }
      this.$dialog.confirm({
        message: `请确认是否撤销“${this.studentInfos.name}”的停课安排？`,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(res=> {
        this.showLoading();
        this.$api.cancelStudentSuspend({
          // studentSuspendId: this.studentSuspendDetail.id
          studentId: this.stuId,
        }).then(res=> {
          this.$toast.clear();
            if (res.code == 200) {
              app.vue.$emit('studentDeatilRefresh');
              app.vue.$emit('refresh-student-list');
              this.$toast.success("撤销成功");
            } else {
              this.$toast.fail(res.msg);
            }
        })
      })
    },
    suspendCourse() {
      if (!app.permission.op('suspend_course')) {
        vant.Dialog.alert({
          title: "提示",
          message: "你没有学员停/复课的权限，请联系管理员",
          confirmButtonText: "我知道了",
        });
        return;
      }
      this.$router.push(`/studentSuspend?studentId=${this.studentInfos.id}&studentName=${this.studentInfos.name}&studentStatus=${this.studentInfos.status}`)
    },
    getPhotoStyle () {
      let { photo } = this.studentInfos;
      return {
        'background-image': `url(${ photo ? studentInfos.photo.url : ''})`
      }
    },
    getStudentBindStatus ({studentParentRelation}) {
      let len = studentParentRelation && studentParentRelation.length;
      if (!len) {
        return false;
      }
      for (let i=0;i<len;i++) {
        let {active} = studentParentRelation[i];
        if (active) return true;
      }
      return false;
    },
    toEWallet (stuId) {
      if(app.permission.op("add_wallet")){
        this.$router.push('/eWallet?id=' + stuId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.student-infos-nav{
  color: var(--g6);
  background: #fff;
  .suspend-nav {
    padding: calc(var(--gap) * 6) calc(var(--gap) * 16);
    color: #ED6A0C;
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    background-color: #FFFBE8;
    &.recovery {
      display: flex;
      align-items: center;
    }
    .cancel {
      text-decoration: underline;
    }
    .van-icon {
      margin-left: calc(var(--gap) * 8);
      font-size:var(--fs-md);
      line-height:var(--lh-md);
    }
  }
  .top-nav{
    position: relative;
    margin: calc(var(--gap) * 20) calc(var(--gap) * 16) calc(var(--gap) * 16);
    display: flex;
    .photo-nav{
      display: flex;
      margin-right: calc(var(--gap) * 8);
      align-items: center;
      justify-content: center;
      width: calc(var(--w) * 54);
      height: calc(var(--w) * 54);
      font-size:var(--fs-ex2);
      line-height:var(--lh-ex2);
      color: var(--white);
      background-size: 100%;
      background-color: var(--c1);
      border-radius: 50%;
      flex-shrink: 0;
    }
    .right-nav{
      flex: 1;
      .name{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: calc(var(--gap) * 4) 0 calc(var(--gap) * 2);
        font-size:var(--fs-ex1);
        line-height:var(--lh-lg);
        color: var(--g8);
        font-weight: 600;
        word-break: break-all;
      }
      .flags-line{
        margin-bottom: calc(var(--gap) * 14);
        display: flex;
        height: auto;
        flex-wrap: wrap;
        overflow: hidden;
        >span{
          display: flex;
          margin: calc(var(--w) * 8) calc(var(--w) * 8) 0 0;
          align-items: center;
          justify-content: center;
          height: calc(var(--w) * 16);
          padding: 0 calc(var(--gap) * 4);
          font-size: var(--fs-xs);
          color: var(--c1);
          background-color: rgba(var(--c1-rgb), 0.12);
          border-radius: calc(var(--radius-base) * 0.5);
          flex-shrink: 0;
          svg{
            font-size: var(--fs-md);
          }
          svg,i{
            margin-right: calc(var(--w) * 2);
          }
          &.is-history {
            color: var(--g6);
            background-color: rgba(var(--g6-rgb), 0.12);
          }
          &.is-unpaid  {
            color: var(--c4);
            background-color: rgba(var(--c4-rgb), 0.12);
          }
          &.is-stop {
            color: var(--c3);
            background-color: rgba(var(--c3-rgb), 0.12);
          }
        }
        .img {
          height: calc(var(--w) * 16);
        }
      }
      .tags-nav{
        margin-top: calc(var(--w) * 6);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        color: var(--g6);
        >span:not(:last-child){            
          padding: 0 calc(var(--w) * 16) 0 0;
          position: relative;
          display: inline-block;
        }
        >span:not(:last-child)::after {
          position: absolute;
          right: calc(var(--w) * 6);
          top: calc(var(--w) * 2);
          bottom: calc(var(--w) * 2);
          content: "";
          width: 1px;
          border-right: 1px solid var(--g6);
          transform: scaleX(0.5);
        }
      }
    }
    .van-icon-arrow{
      color: var(--g6);
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
    }
  }
  .wallet-nav{
    display: flex;
    justify-content: space-between;
    margin: 0 calc(var(--gap) * 16);
    padding: 0 calc(var(--gap) * 12);
    height: calc(var(--w) * 32);
    align-items: center;
    background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0089.png) center/cover no-repeat;
    .left{
      display: flex;
      align-items: center;
      svg{
        margin-right: calc(var(--gap) * 4);
      }
      >span>span{
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
      }
    }
  }
  .no-wallet-line{
    margin: 0 calc(var(--gap) * 16);
    height: 1px;
    background: var(--g3);
  }
  .operation-nav{      
    padding: calc(var(--gap) * 12) 0 calc(var(--gap) * 4);
    display: flex;
    margin: 0 calc(var(--w) * 16) calc(var(--w) * 4);
    height: calc(var(--w) * 74);
    >div{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      >i {
        height: calc(var(--w) * 24);
        width: calc(var(--w) * 24);
        margin-bottom: calc(var(--w) * 4);
        background-size: calc(var(--w) * 24);
        &.call{ 
          background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0009.png?t=1623047937522');
        }
        &.more{ 
          background-image: url('https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0010.png?t=1623047937522');
        }
      }
      
      &.disabled{
        opacity: 0.5;
      }
    }
  }
  .tels-sheet-content {
    .van-action-sheet__item {
      box-sizing: border-box;
      text-align: center;
      color: var(--g8);
      > span {
        padding-left: calc(var(--gap) * 4);
        color: var(--g6);
      }
    }
  }
}

</style>
<style lang="scss">
.student-to-old-dialog-contain{
  margin: calc(var(--gap) * 10) calc(var(--gap) * 24) 0;
  color: var(--g6);
  font-size:var(--fs-md);
  line-height:var(--lh-md);
  .tips-contain{
    max-height: calc(var(--w) * 300);
    padding: calc(var(--gap) * 16);
    margin: calc(var(--gap) * 10) 0 calc(var(--gap) * 24);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    background: var(--g1);
    border-radius: var(--radius-base);
    overflow-y: auto;
    .desc {
      color: var(--c3);
    }
    li,p{
      margin: calc(var(--gap) * 8) 0;
    }
    p:first-child{
      margin-top: 0;
    }
    li:last-child{
      margin-bottom: 0;
    }
  }
  .tips-contain>ol{
    padding-inline-start: calc(var(--gap) * 16);
    list-style: decimal;
    >li{
      padding-left: calc(var(--gap) * 6);
    }
  }
}
</style>